export const getTopicDescription = ({
    creatorDisplayName,
    categoryName,
    hasArticle,
}: {
    creatorDisplayName: string;
    categoryName?: string | null;
    hasArticle?: boolean | null;
}): string => {
    return `${
        hasArticle ? `${/^[aeiou]/i.test(creatorDisplayName) ? 'an' : 'a'} ` : ''
    }${creatorDisplayName} ${categoryName}`;
};
